import React from "react";
import { AUTH_LABELS, AUTH_MESSAGES } from "../constants/authConstants";
import { User, Lock, KeyRound } from "lucide-react";

const LoginForm = ({
  credentials,
  newPassword,
  loading,
  error,
  needsPasswordChange,
  showDirectLogin,
  handleSubmit,
  handlePasswordChange,
  handleChange,
  setNewPassword,
  toggleDirectLogin,
  isOktaEnabled,
}) => {
  return (
    <div className="space-y-4">
      <form
        onSubmit={needsPasswordChange ? handlePasswordChange : handleSubmit}
        className="space-y-4"
      >
        {!needsPasswordChange ? (
          <>
            <div className="space-y-1.5">
              <label className="block text-sm font-medium text-gray-300">
                {AUTH_LABELS.USERNAME}
              </label>
              <div className="relative">
                <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500">
                  <User size={16} />
                </span>
                <input
                  type="text"
                  name="username"
                  value={credentials.username}
                  onChange={handleChange}
                  className="w-full bg-gray-800 border border-gray-700 text-white rounded-lg pl-10 pr-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-lla-orange focus:border-transparent transition-all placeholder:text-gray-500"
                  placeholder="Enter your username"
                  required
                />
              </div>
            </div>
            <div className="space-y-1.5">
              <label className="block text-sm font-medium text-gray-300">
                {AUTH_LABELS.PASSWORD}
              </label>
              <div className="relative">
                <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500">
                  <Lock size={16} />
                </span>
                <input
                  type="password"
                  name="password"
                  value={credentials.password}
                  onChange={handleChange}
                  className="w-full bg-gray-800 border border-gray-700 text-white rounded-lg pl-10 pr-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-lla-orange focus:border-transparent transition-all placeholder:text-gray-500"
                  placeholder="Enter your password"
                  required
                />
              </div>
            </div>
          </>
        ) : (
          <div className="space-y-1.5">
            <label className="block text-sm font-medium text-gray-300">
              {AUTH_LABELS.NEW_PASSWORD}
            </label>
            <div className="relative">
              <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500">
                <KeyRound size={16} />
              </span>
              <input
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                className="w-full bg-gray-800 border border-gray-700 text-white rounded-lg pl-10 pr-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-lla-orange focus:border-transparent transition-all placeholder:text-gray-500"
                required
                placeholder={AUTH_LABELS.NEW_PASSWORD_PLACEHOLDER}
              />
            </div>
            <p className="text-xs text-gray-400">
              {AUTH_MESSAGES.PASSWORD_CHANGE_REQUIRED}
            </p>
          </div>
        )}

        {error && (
          <div className="text-red-400 text-sm text-center bg-red-900/30 border border-red-800 p-3 rounded-lg">
            {error}
          </div>
        )}

        <button
          type="submit"
          className="w-full bg-gray-600 hover:bg-[#F26522] text-white font-semibold py-3 px-6 rounded-lg transition-colors duration-200 disabled:opacity-60 disabled:cursor-not-allowed shadow-lg"
          disabled={loading}
        >
          {loading
            ? needsPasswordChange
              ? AUTH_MESSAGES.CHANGING_PASSWORD
              : AUTH_MESSAGES.SIGNING_IN
            : needsPasswordChange
            ? AUTH_MESSAGES.CHANGE_PASSWORD
            : AUTH_MESSAGES.SIGN_IN}
        </button>
      </form>

      {/* Botón para regresar a Okta */}
      {isOktaEnabled() && showDirectLogin && (
        <button
          type="button"
          onClick={toggleDirectLogin}
          className="w-full text-gray-400 hover:text-gray-200 text-xs mt-2 transition-colors"
        >
          ← Back to Okta login
        </button>
      )}
    </div>
  );
};

export default LoginForm;
